// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__L3m-E","input":"Form_input__rNNGb","button":"Form_button__-gZDD","select":"Form_select__1KvUS"};